module.exports = __webpack_public_path__ + "img/maintenance.090243a7.svg";